import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const TransferOnline4bStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  logo: {
    margin: "1rem 0",
    "& img": {
      width: "25%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  TransferOnline4b_label0: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  TransferOnline4b_label1: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  TransferOnline4b_label2: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  TransferOnline4b_label3: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  TransferOnline4b_sepa_bold: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#FFDD00",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  TransferOnline4b_sepa_normal: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  //-------
  //Buttons
  //-------
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 20,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
});

export default TransferOnline4bStyle;
